import { useCallback } from 'react';
import { Share, type ShareProps } from '../components/share';
import { useOpenModal } from '../../next-modal';
import { isBuildIn } from '../../build-in';
import { isMobile } from 'react-device-detect';
import { ShareList } from '../components/share-list';
import { modalId } from './utils';
export const useOpenShare = () => {
  const openModal = useOpenModal();

  return useCallback(
    (e: React.MouseEvent, props: ShareProps) => {
      const buildin = isBuildIn();
      if (buildin || isMobile) {
        openModal.modal({
          modalId,
          className: 'overflow-hidden',
          center: !isMobile,
          content: () => <Share {...props} />,
        });
      } else {
        openModal.dropdown({
          placement: 'top-end',
          popcorn: e.currentTarget,
          content: () => <ShareList {...props} />,
        });
      }
    },
    [openModal]
  );
};
